import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"

import { isFeatureEnabled, type FeatureFlag } from "./featureFlags"

interface FeatureGateProps {
  flag: FeatureFlag
  /** Where to send the user when the flag is off. Defaults to `/`. */
  redirectTo?: string
  children: ReactNode
}

/** Route-level guard: renders children only when the compile-time flag is on. */
export function FeatureGate({
  flag,
  redirectTo = "/",
  children,
}: FeatureGateProps) {
  if (!isFeatureEnabled(flag)) {
    return <Navigate to={redirectTo} replace />
  }
  return children
}
